import React from "react";
import "./PaymentPreviewCard.css"; // CSS file with updated class names

const PaymentPreviewCard = ({
  baseAmount,
  gstRate,
  discount,
  serviceCharge,
  servicePoints = [],
}) => {
  const base = Number(baseAmount) || 0;
  const gst = Number(gstRate) || 0;
  const discountAmount = Number(discount) || 0;
  const taxableAmount = Math.max(base - discountAmount, 0);
  const gstAmount = (taxableAmount * gst) / 100;
  const finalAmount = taxableAmount + gstAmount;


  return (
    <div >
    

      {Array.isArray(servicePoints) && servicePoints.length > 0 && (
        <div className="payment-section payment-services">
          <h3 className="payment-services-title">Services Included</h3>
          <ul className="payment-services-list">
            {servicePoints.map((point, index) => (
              <li key={index}>{point}</li>
            ))}
          </ul>
        </div>
      )}

      <div className="payment-section payment-details">
        <div className="payment-row">
          <span>Base Amount</span>
          <span>₹{base.toLocaleString()}</span>
        </div>

        {discountAmount > 0 && (
          <div className="payment-row">
            <span>Discount</span>
            <span>-₹{discountAmount.toLocaleString()}</span>
          </div>
        )}

        {discountAmount > 0 && (
          <div className="payment-row">
            <span>Final Amount</span>
            <span>₹{taxableAmount.toFixed(2)}</span>
          </div>
        )}

        <div className="payment-row">
          <span>GST ({gstRate}%)</span>
          <span>₹{gstAmount.toFixed(2)}</span>
        </div>
        <div className="payment-divider" />

        <div className="payment-row total">
          <span>Total to Pay</span>
          <span>₹{finalAmount.toFixed(2)}</span>
        </div>
      </div>

      {/* <p className="payment-note">No refund after successful payment.</p> */}
    </div>
  );
};

export default PaymentPreviewCard;

